import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Profile,
  Notifications,
  Statistics
} from "components/Homeowner/Dashboard";
import { ResultGrid } from "components/Search";
import { MSpinner } from "components/Shared";
import { CaseFormWrapper } from "components/Homeowner/CaseForms";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.toggleHeaderClassName = this.toggleHeaderClassName.bind(this);
    this.state = {
      headerClassName: "header-contracted"
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getDashboard();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(!nextProps.gotInitialGridFilters) {
      this.props.getGridFilters();
    }
    if (!nextProps.gotInitialGridFilterMenus && this.props.gridFilters) {
      this.props.getGridFilterMenus();
    }
    if (!nextProps.isFetchingGridFilters && this.props.isFetchingGridFilters) {
      this.props.refreshCaseList();
    }
  }

  formStatusChange() {}

  toggleHeaderClassName() {
    this.state.headerClassName === "header-expanded"
      ? this.closeHeader()
      : this.openHeader();
  }

  closeHeader() {
    this.setState({
      headerClassName: "header-contracted"
    });
  }

  openHeader() {
    this.setState({
      headerClassName: "header-expanded"
    });
  }

  mapDataForMapControl(rows) {
    let pins = rows.map(row => {
      return {
        id: row.controlIDNumber,
        latitude: row.latitude,
        longitude: row.longitude
      };
    });
    return pins.filter(
      pin =>
        pin.latitude != null &&
        pin.latitude != "" &&
        pin.longitude != null &&
        pin.longitude != ""
    );
  }

  render() {
    const {
      isFetchingCaseList,
      isFetchingSearchList,
      isFetchingGridFilterMenus,
      isFetchingProfile,
      isFetchingNotifications,
      isFetchingStatistics,
      isFetchingGridFilters,
      gridFilters,
      caseListItems,
      searchListItems,
      searchText,
      profile,
      userProfile,
      notifications,
      statistics,
      isAppraiser,
      isAppraiserManager,
      gridFilterMenus
    } = this.props;
    if (isFetchingGridFilters || isFetchingGridFilterMenus) {
      return <MSpinner />;
    }

    // set proper Row Type based on roles
    let rowType = userProfile.isMortgageBroker
      ? "Broker"
      : isAppraiser || isAppraiserManager
        ? "Appraisal"
        : "Homeowner";

    return (
      <div
        className={"case-list case-form-wrapper " + this.state.headerClassName}
      >
        <div className="override-case-form-wrapper-width">
          <CaseFormWrapper
            formId="home-header"
            formTitle="Overview"
            formStatusChange={this.formStatusChange}
            formStatus="clean"
            toggleHeaderClassName={this.toggleHeaderClassName}
            comp={
              <div className="case-list case-header md-grid">
                <Profile
                  isFetching={isFetchingProfile}
                  profile={profile}
                  userProfile={userProfile}
                  isAppraiserManager={isAppraiserManager}
                />
                <Statistics
                  isFetching={isFetchingStatistics}
                  statistics={statistics}
                  isAppraiserManager={isAppraiserManager}
                />
                <Notifications
                  isFetching={isFetchingNotifications}
                  items={notifications}
                />
              </div>
            }
          />
        </div>

        <div className="md-cell md-cell--12 md-cell--right">
          <ResultGrid
            isFetchingCaseList={isFetchingCaseList}
            isFetchingSearchResults={isFetchingSearchList}
            isFetchingGridFilterMenus={isFetchingGridFilterMenus}
            caseListItems={caseListItems}
            searchListItems={searchListItems}
            searchText={searchText}
            isAppraiserManager={isAppraiserManager}
            isAppraiser={isAppraiser}
            rowType={rowType}
            gridFilters={gridFilters}
            refreshCaseList={this.props.refreshCaseList}
            refreshSearchList={this.props.refreshSearchList}
            changeGridFilters={this.props.changeGridFilters}
            gridFilterMenus={gridFilterMenus}
            getGridFilters={this.props.getGridFilters}
            mapDataForMap={this.mapDataForMapControl}
            resizeRequired={this.props.resizeRequired}
            resizeComplete={this.props.resizeComplete}
            clientSideFilters={this.props.clientSideFilters}
            saveClientSideFilters={this.props.saveClientSideFilters}
            clearClientSideFilters={this.props.clearClientSideFilters}
          />
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  isAppraiser: PropTypes.bool.isRequired,
  isAppraiserManager: PropTypes.bool.isRequired,

  isFetchingCaseList: PropTypes.bool.isRequired,
  isFetchingSearchList: PropTypes.bool.isRequired,

  isFetchingGridFilterMenus: PropTypes.bool,
  isFetchingProfile: PropTypes.bool.isRequired,
  isFetchingNotifications: PropTypes.bool.isRequired,
  isFetchingStatistics: PropTypes.bool.isRequired,
  isFetchingGridFilters: PropTypes.bool.isRequired,

  caseListItems: PropTypes.object.isRequired,
  searchListItems: PropTypes.object.isRequired,
  searchText: PropTypes.string.isRequired,

  profile: PropTypes.object.isRequired,
  userProfile: PropTypes.object.isRequired,
  notifications: PropTypes.array.isRequired,
  statistics: PropTypes.object.isRequired,
  gridFilters: PropTypes.array.isRequired,
  gridFilterMenus: PropTypes.object.isRequired,
  getDashboard: PropTypes.func.isRequired,

  gotInitialGridFilterMenus: PropTypes.bool.isRequired,
  gotInitialGridFilters: PropTypes.bool.isRequired,

  refreshCaseList: PropTypes.func.isRequired,
  refreshSearchList: PropTypes.func.isRequired,
  changeGridFilters: PropTypes.func.isRequired,

  getGridFilters: PropTypes.func.isRequired,
  getGridFilterMenus: PropTypes.func.isRequired,

  resizeRequired: PropTypes.bool,
  resizeComplete: PropTypes.func.isRequired,

  clientSideFilters: PropTypes.object.isRequired,
  saveClientSideFilters: PropTypes.func.isRequired,
  clearClientSideFilters: PropTypes.func
};

export default Dashboard;
